<template>
    <div id="apiary-hives-localisation-widget-component">
        <WidgetWrapperComponent :title="$t('global_apiary.location_hives')" id-widget="apiary-hives-localisation-widget">
            <template v-slot:default>
                <gmap-map ref="gmap" :zoom="12" :center="{ lat: 47, lng: 5 }" style="height: 400px" class="google-map-container">
                    <gmap-marker
                        v-for="(hive, index) in hives"
                        :key="index"
                        :position="{ lat: parseFloat(hive.domicile.latitude), lng: parseFloat(hive.domicile.longitude) }"
                        :title="hive.name"
                        @click="openMarkerByIndex(index)"
                    >
                        <gmap-info-window :opened="opened_marker_index === index" @closeclick="opened_marker_index = null">
                            <div>
                                <div class="font-weight-bold font-16 font-color-default pb-2">
                                    {{ hive.name }}
                                </div>

                                <div class="pb-2">
                                    <v-icon class="font-color-medium align-stretch" dense> mdi-map-marker-outline </v-icon>
                                    {{ displayToHumanDomicileAddress(hive.domicile) }}
                                </div>

                                <template v-for="device in hive.devices">
                                    <div :key="device.id_device">
                                        <div class="display-flex-align-center gap-2 mb-1">
                                            <v-icon class="font-color-medium align-stretch" dense> mdi-remote </v-icon>

                                            {{ device.device_number }}

                                            <ChipsLastStatement :date="device.date_last_emission" colorless />
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </gmap-info-window>
                    </gmap-marker>
                </gmap-map>
            </template>
        </WidgetWrapperComponent>
    </div>
</template>

<script>
import displayHuman from '@/mixin/displayHuman'
import WidgetWrapperComponent from '@/components/global/wrapper/WidgetWrapperComponent.vue'
import ChipsLastStatement from '@/components/global/containment/ChipsLastStatement.vue'

export default {
    name: 'ApiaryHivesLocalisationWidgetComponent',
    components: { ChipsLastStatement, WidgetWrapperComponent },
    mixins: [displayHuman],
    props: {
        hives: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            opened_marker_index: null,
        }
    },
    watch: {
        hives() {
            this.fitBoundsMap()
        },
    },
    methods: {
        fitBoundsMap() {
            const google = window.google

            if (google) {
                const bounds = new window.google.maps.LatLngBounds()
                this.hives?.forEach((hive) => {
                    bounds.extend(new window.google.maps.LatLng(hive.domicile.latitude, hive.domicile.longitude))
                })
                this.$refs.gmap.fitBounds(bounds)
            } else {
                setTimeout(() => {
                    this.fitBoundsMap()
                }, 500)
            }
        },

        openMarkerByIndex(index) {
            this.opened_marker_index = index
        },
    },
    mounted() {
        this.fitBoundsMap()
    },
}
</script>